import { render, staticRenderFns } from "./OrderStatusLabel.vue?vue&type=template&id=e71e4dae&scoped=true&"
import script from "./OrderStatusLabel.vue?vue&type=script&lang=js&"
export * from "./OrderStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusLabel.vue?vue&type=style&index=0&id=e71e4dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71e4dae",
  null
  
)

export default component.exports